module.exports = __webpack_public_path__ + "static/img/__9089.5d906f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9089.jpg
// module id = pE/i
// module chunks = 0